import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { CalibrationBalance } from '../../../../model/calibrationBalance';
import { CalibrationBalanceReportFilter } from '../../../../model/attachment';
import { LangFlag, TranslationService } from '../../../../services/translation.service';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CalibrationBalanceService } from '../../../../services/calibrationBalance.service';
import { InternalEquipmentService } from '../../../../services/internalEquipment.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { ActionConfirmPasswordComponent } from '../../../shared/action-confirm-password/action-confirm-password.component';
import { InternalEquipment } from '../../../../model/internalEquipment';
import { CalibrationBalanceUtils } from '../../../../utils/calibrationBalanceUtils';
import { saveAs } from 'file-saver';

export interface DialogDataManualSignCalibrationBalance {
  calibration: CalibrationBalance;
}

@Component({
  selector: 'app-calibration-balance-edit-manual-sign-report',
  templateUrl: './calibration-balance-edit-manual-sign-report.component.html',
  styles: [],
  standalone: false
})
export class CalibrationBalanceEditManualSignReportComponent implements OnInit, OnDestroy {

  reportConfig: CalibrationBalanceReportFilter;
  langs: LangFlag[];

  private destroy$ = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<CalibrationBalanceEditManualSignReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataManualSignCalibrationBalance,
    private calibrationService: CalibrationBalanceService,
    private internalEquipmentService: InternalEquipmentService,
    private translate: TranslateService,
    private translationService: TranslationService,
    public dialog: MatDialog,
    public snackBarService: SnackBarService,
    private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.reportConfig = new CalibrationBalanceReportFilter();
    this.reportConfig.lang = this.translationService.currentLang;

    this.langs = this.translationService.configuredLangs;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  downloadDocument(): void {
    this.spinnerService.show();

    this.reportConfig.reason = this.data.calibration.reason;

    this.calibrationService.downloadPdf(this.data.calibration.id, this.reportConfig).pipe(takeUntil(this.destroy$))
      .subscribe((res: File) => {
        this.downloadFile(this.data.calibration, res);
      }, () => {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.generic') as string);
        this.spinnerService.hide();
      });
  }

  onOkClick(event): void {
    const file = event.target.files[0] as File;

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {

      if (token != null) {
        this.spinnerService.show();

        this.calibrationService.manualSign(this.data.calibration, file, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.sign.ok') as string);

          this.spinnerService.hide();

          this.dialogRef.close(token);
        }, () => {
          this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.sign.error') as string);

          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.hide();
      }
    });

  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }

  private downloadFile(calibration: CalibrationBalance, file: File) {
    this.spinnerService.show();

    this.internalEquipmentService.findOne(calibration.idEquipment).pipe(takeUntil(this.destroy$))
      .subscribe((equipment: InternalEquipment) => {
        const name = CalibrationBalanceUtils.getNameForCalibration(this.data.calibration, equipment, this.translate);
        saveAs(file, name);
        this.spinnerService.hide();
      }, () => {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.generic') as string);
        this.spinnerService.hide();
      });
  }
}
